// By default, a react-dom module is exported; see code/main/* for other options
module.exports = require('./code/main/react-dom')


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon6/react.js
// module id = 462
// module chunks = 127651196306611